module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessDelete(_vm.FUNCTIONALITY) && _vm.hasUpdatableForecasts) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Forecasts")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('ItemManager', {
    attrs: {
      "item": _vm.convertedItem,
      "do-save": _vm.doSave
    },
    on: {
      "saved": function($event) {
        _vm.doSave = false;
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('ClientColorButton', {
    attrs: {
      "class-name": 'button'
    },
    on: {
      "click": function($event) {
        _vm.doSave = true;
      }
    }
  }, [_vm._v("Update selected forecasts")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36ca42b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/ItemDetail.vue
// module id = 3120
// module chunks = 0